import { Box, Stack, Text } from "@mantine/core";
import { IconTruck } from "@tabler/icons-react";
import { useAppForm } from "../../hooks/preferenceForm";
import { OfficeDetailsPreferences } from "./components/OfficeDetailsPreferences";
import { ScopePreferences } from "./components/ScopePreferences";
import { getDeliveryPreferenceDefaults } from "./deliveryPreferenceForm";

const DeliveryPreferences = () => {
  const form = useAppForm({
    defaultValues: getDeliveryPreferenceDefaults(),
  });

  return (
    <form>
      <Stack pb="s16">
        <OfficeDetailsPreferences form={form} />

        <ScopePreferences form={form} />

        <Box
          display="flex"
          p="s4"
          bg="var(--mantine-color-ink-0)"
          bdrs="md"
          style={{
            alignItems: "center",
            gap: "var(--mantine-spacing-s3)",
            border: "1px solid var(--mantine-color-ink-1)",
          }}
        >
          <IconTruck size={22} color="var(--mantine-color-ink-6)" />
          <Text>
            Transporteur, mode d&lsquo;envoi des empreintes et aperçu de design
            sont pilotés par Jasper : ils ne se règlent pas ici.
          </Text>
        </Box>
      </Stack>
    </form>
  );
};

export default DeliveryPreferences;
